/* eslint-disable no-console */
import {register} from 'register-service-worker'
import {log} from "@/utils/clientLogger.js";

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
    try {
        register(`${process.env.BASE_URL}sw.js`, {
            ready() {
                log.info(
                    'ServiceWorker:Register:register',
                    {
                        'message': 'App is being served from cache by a service worker. For more details, visit https://goo.gl/AFskqB',
                    }
                )
            },
            registered() {
                log.info('ServiceWorker:Register:registered', {'message': 'Service worker has been registered.'})
            },
            cached() {
                log.info('ServiceWorker:Register:cached', {'message': 'Content has been cached for offline use.'})
            },
            updatefound() {
                log.info('ServiceWorker:Register:updatefound', {'message': 'New content is downloading.'})
            },
            updated() {
                log.info('ServiceWorker:Register:updated', {'message': 'New content is available; please refresh.'})
            },
            offline() {
                log.info('ServiceWorker:Register:offline', {'message': 'No internet connection found. App is running in offline mode.'})
            },
            error(error) {
                log.error('ServiceWorker:Register:error', {'error': error})
            }
        })
    }catch (e) {
        log.error(
            'ServiceWorker:Register',
            {
                'error': e,
            }
        )
    }
}